import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"



interface Prop {
  title: string,
  caption: string,
  onClick: () => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactItem',
  props: {
    title: null,
    caption: null,
    onClick: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    clickable: "",
    class: "q-mb-lg q-ml-md contentItem",
    onClick: __props.onClick
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, { avatar: "" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "avater")
        ]),
        _: 3
      }),
      _createVNode(_component_q_item_section, { style: {"font-size":"x-large"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_label, { caption: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.caption), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, {
        side: "",
        top: ""
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "side")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["onClick"]))
}
}

})